var map = {
	"./KAB-token.png": 293,
	"./OKG-token.png": 173,
	"./divider.png": 747,
	"./icon-bybit-button.png": 578,
	"./icon-checkbox-no.png": 381,
	"./icon-checkbox-yes.png": 382,
	"./icon-cocoon.png": 1072,
	"./icon-double-heart-left.png": 788,
	"./icon-double-heart-right.png": 755,
	"./icon-email-success.png": 566,
	"./icon-filter.png": 789,
	"./icon-get-KAB.png": 1073,
	"./icon-get-OKG.png": 1074,
	"./icon-hero.png": 1075,
	"./icon-logout.png": 579,
	"./icon-mana-deactive.png": 580,
	"./icon-mana.png": 581,
	"./icon-pancakeswap-button.png": 582,
	"./icon-power.png": 549,
	"./icon-radio-button-checked.png": 790,
	"./icon-radio-button.png": 791,
	"./icon-success.png": 131,
	"./icon-warning.png": 583,
	"./round-rock-icon.png": 1076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;